/**
 * The preview's morph, on the directory tile.
 *
 * While an artifact is being written the preview plays the morph band over the frame; the tile used
 * to sit still beside it (Guri, 2026-09-08: "on the left side, in the directory part, it does not do
 * anything", then "reuse that same morph effect here"). This mounts the SAME element `useGenMorph`
 * hands the stage, at the artifact's natural 1920x1080, and scales it to whatever width the tile
 * has. One gen record, two views of it: when the record ends, both go together.
 */
import { useLayoutEffect, useRef, useState } from 'react';
import type { GenKey } from '../generate/genBus';
import { ARTIFACT_H, ARTIFACT_W } from '../preview/artifactStage';
import { useGenMorph } from '../preview/useStageForX';

export function ArtifactTileMorph({ slideId }: { slideId: GenKey }) {
  const gen = useGenMorph(slideId, { bandWhileStreaming: true });
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => setWidth(el.clientWidth);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [gen.morph]);
  if (!gen.morph) return null;
  return (
    <div ref={ref} style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
      <div
        style={{
          width: ARTIFACT_W,
          height: ARTIFACT_H,
          transformOrigin: '0 0',
          transform: `scale(${width > 0 ? width / ARTIFACT_W : 0})`,
        }}
      >
        {gen.morph}
      </div>
    </div>
  );
}
